import _ from 'lodash';
import { connect } from 'react-redux';
import AddGlowforge from 'app/components/setup/add-glowforge';

const mapStateToProps = state => ({
  downloadUrl: `${_.get(state.common, 'features').GFCORE_SITE_URL}/setup/download`,
});

const AddGlowforgeContainer = connect(mapStateToProps)(AddGlowforge);

export default AddGlowforgeContainer;



// WEBPACK FOOTER //
// ./app/containers/setup/add-glowforge.js